import React from 'react';
import styled from '@emotion/styled';
import { themeGet } from 'styled-system';
import { Box, Link, Hide } from 'roo-ui/components';

import HeaderDesktop from './HeaderDesktop';
import HeaderPhone from './HeaderPhone';

const StickyHeader = styled(Box)`
  top: 0;
  z-index: ${themeGet('zIndices.header')};
  background-color: white;
`;

const Header = () => (
  <StickyHeader data-print-style="no-border">
    <Link to="#content" hidden>
      Skip Global Header to Content
    </Link>
    <Hide xs sm>
      <HeaderDesktop />
    </Hide>
    <Hide md lg>
      <HeaderPhone />
    </Hide>
  </StickyHeader>
);

export default Header;
